import {
  GET_TYPE_SERVICE_PROFILE,
  GET_TYPE_SERVICE_PROFILE_FAIL,
  GET_TYPE_SERVICE_PROFILE_SUCCESS,
  GET_TYPE_SERVICES,
  GET_TYPE_SERVICES_FAIL,
  GET_TYPE_SERVICES_SUCCESS,
  ADD_NEW_TYPE_SERVICE,
  ADD_TYPE_SERVICE_SUCCESS,
  ADD_TYPE_SERVICE_FAIL,
  UPDATE_TYPE_SERVICE,
  UPDATE_TYPE_SERVICE_SUCCESS,
  UPDATE_TYPE_SERVICE_FAIL,
  DELETE_TYPE_SERVICE,
  DELETE_TYPE_SERVICE_SUCCESS,
  DELETE_TYPE_SERVICE_FAIL,
} from "./actionTypes"

export const getType_services = ({vendor_type_id,is_active,offset='',page_size=''}) => ({
  type: GET_TYPE_SERVICES,
  payload:{vendor_type_id,is_active,offset,page_size}
})

export const getType_servicesSuccess = data => ({
  type: GET_TYPE_SERVICES_SUCCESS,
  payload: data,
})

export const getType_servicesFail = error => ({
  type: GET_TYPE_SERVICES_FAIL,
  payload: error,
})

export const addNewType_service = user => ({
  type: ADD_NEW_TYPE_SERVICE,
  payload: user,
})

export const addType_serviceSuccess = user => ({
  type: ADD_TYPE_SERVICE_SUCCESS,
  payload: user,
})  

export const addType_serviceFail = error => ({
  type: ADD_TYPE_SERVICE_FAIL,
  payload: error,
})

export const updateType_service = user => ({
  type: UPDATE_TYPE_SERVICE,
  payload: user,
})

export const updateType_serviceSuccess = user => ({
  type: UPDATE_TYPE_SERVICE_SUCCESS,
  payload: user,
})

export const updateType_serviceFail = error => ({
  type: UPDATE_TYPE_SERVICE_FAIL,
  payload: error,
})

export const deleteType_service = user => ({
  type: DELETE_TYPE_SERVICE,
  payload: user,
})

export const deleteType_serviceSuccess = user => ({
  type: DELETE_TYPE_SERVICE_SUCCESS,
  payload: user,
})

export const deleteType_serviceFail = error => ({
  type: DELETE_TYPE_SERVICE_FAIL,
  payload: error,
})

export const getType_serviceProfile = () => ({
  type: GET_TYPE_SERVICE_PROFILE,
})

export const getType_serviceProfileSuccess = userProfile => ({
  type: GET_TYPE_SERVICE_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getType_serviceProfileFail = error => ({
  type: GET_TYPE_SERVICE_PROFILE_FAIL,
  payload: error,
})
